import {
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { addressSelectionUI } from 'platform/shared/health-apps';
import content from '../../../locales/en/content.json';

const TITLE_TEXT = content['secondary-one-address--selection-title'];
const INPUT_LABELS = {
  selection: content['secondary-one-address--selection-label'],
  sameAs: content['secondary-one-address--same-as-label'],
};

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    'view:secondaryOneSharedAddress': addressSelectionUI({
      title: INPUT_LABELS.selection,
      destinationKey: 'secondaryOneAddress',
      sourceKeys: ['veteranAddress', 'primaryAddress'],
    }),
    'view:secondaryOneHomeSameAsMailingAddress': yesNoUI(INPUT_LABELS.sameAs),
  },
  schema: {
    type: 'object',
    required: [
      'view:secondaryOneSharedAddress',
      'view:secondaryOneHomeSameAsMailingAddress',
    ],
    properties: {
      'view:secondaryOneSharedAddress': { type: 'string' },
      'view:secondaryOneHomeSameAsMailingAddress': yesNoSchema,
    },
  },
};
